/* eslint-disable no-param-reassign */
import { getToken } from "@ctsu/loader";
import { log } from "protocol-setup/helpers";

async function makeRawRequest(url, method, body, auth, header = new Headers()) {
  const token = getToken();

  header.append("Content-Type", "application/json");
  if (auth) {
    header.append("Authorization", `Bearer ${token}`);
  } else {
    header.append("appName", process.env.REACT_APP_NAME);
  }
  const params = {
    crossDomain: !auth,
    withCredentials: !auth,
    credentials: "include",
    headers: header
  };
  if (auth) {
    delete params.credentials;
  }
  if (body && body.abortSignal) {
    params.signal = body.abortSignal;
    delete body.abortSignal;
  }
  if (body) {
    params.body = typeof body !== "string" ? JSON.stringify(body) : body;
  }
  const requestConfig = { method, ...params };
  return fetch(url, requestConfig);
}

// This function processes the raw response based on its content type
async function processResponse(response) {
  let jsonResponse;
  let textResponse;
  const { status } = response;
  if (status === 200) {
    textResponse = await response.text();
    try {
      jsonResponse = JSON.parse(textResponse);
    } catch (error) {
      jsonResponse = textResponse;
    }
    return jsonResponse;
  }
  log('Handling error response...');
  try {
    textResponse = await response.json();
    log('Error response parsed:', textResponse);
  } catch (parseError) {
    log('Failed to parse error response as JSON:', parseError);
    try {
      textResponse = await response.text();
      log('Error response as text:', textResponse);
    } catch (textError) {
      log('Failed to get response as text:', textError);
      textResponse = `HTTP ${status} - Failed to read response`;
    }
  }

  log('About to reject with:', textResponse);
  return Promise.reject(textResponse);
}

// This function combines makeRawRequest and processResponse
async function makeRequest(url, method, body, auth, header) {
  const response = await makeRawRequest(url, method, body, auth, header);
  return processResponse(response);
}

export const fetchWithAuth = url => makeRequest(url, "GET", false, true);
export const postWithAuth = (url, body) => makeRequest(url, "POST", body, true);
export const putWithAuth = (url, body) => makeRequest(url, "PUT", body, true);
export const deleteWithAuth = url => makeRequest(url, "DELETE", false, true);
export const fetchRequest = (url, header) => makeRequest(url, "GET", false, false, header);
export const postRequest = (url, body) => makeRequest(url, "POST", body, false);
export const putRequest = (url, body) => makeRequest(url, "PUT", body, false);

export function makeFetchRequestBase({ url, method, body }) {
  if (method === "GET") {
    return makeRawRequest(url, "GET", false, true);
  }
  if (method === "POST") {
    return makeRawRequest(url, "POST", body, true);
  }
  if (method === "PUT") {
    return makeRawRequest(url, "PUT", body, true);
  }
  return makeRawRequest(url, method, body, true);
}
